<template>
  <div>
    <div id="offerDashboard">
      <div id="content-form">
        <v-container fluid >
            <v-row>
              <v-col cols="12" sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
                <SideMenu/>
              </v-col>
              <v-col cols="12" sm="8" md="9" lg="10" class="nav-right pt-14">
                <div class="card-layout">
                  <v-row justify="center" class="py-0">
                    <v-col cols="11" class="ma-0 pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col cols="9"  class="d-flex align-center px-0 py-2">
                          <div class="text-center text-sm-left d-block d-sm-inline-block">
                            <h2 class="text-center text-sm-left">{{offer.title}}</h2>
                          </div>
                          <div class="text-center text-sm-left d-block d-sm-inline-block" v-if="offer.status !== 'close'">
                            <v-btn
                              text
                              color="info"
                              class="text-center text-sm-left ml-8 py-0"
                              :to="`/offer/edit/${offer.slug}`"
                            >
                              <v-icon size="20" left small color="info">mdi-pencil-box-multiple-outline</v-icon>
                              Editar oferta
                            </v-btn>
                          </div>
                          <div class="text-center text-sm-left d-block d-sm-inline-block">
                          </div>
                        </v-col>
                        <v-col cols="12" md="3" lg="3" xl="3" class="text-md-right text-lg-right text-xl-right text-center">
                          <v-btn color="info" @click="downloadSheet" :loading="isDownload">
                            DESCARGA POSTULANTES
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="py-2">
                    <v-col cols="10" sm="11" class="pa-0">
                      <div class="txt-description">
                        <p class="px-5 py-4 ma-0">
                          ¡Gestiona tu proceso de selección! Puedes revisar fácilmente los postulantes
                          y moverlos de fases. Arrastra las columnas o usa los menús
                          (<v-icon>mdi-dots-vertical</v-icon>).
                          Desde ahí puedes también enviar un correo y descargar su CV. Al hacer click
                          en la tarjeta puedes ver el detalle del perfil y de su postulación.
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                  <v-container class="tab-scroll-table">
                    <v-col class="tab-drag mx-auto d-flex justify-space-between">
                      <v-col
                        cols="3"
                        sm="3"
                        md="3"
                        lg="3"
                        v-for="(item, index) in cols"
                        :key="index"
                        class="ats-col mx-2"
                      >
                        <v-col
                          cols="12"
                          class="d-flex justify-space-between align-center ats-col__header py-0"
                        >
                          <h3 class="ats-col__header-title pa-0">
                            {{ item.name.toUpperCase() }} ({{ postulations[item.status].length }})
                          </h3>
                          <v-col class="d-flex justify-end aling-center pa-0 mx-0">
                            <v-menu
                              bottom
                              offset-y
                              class="d-flex ma-0 pa-0"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon small v-bind="attrs" v-on="on">
                                  mdi-dots-vertical
                                </v-icon>
                              </template>
                                <v-list class="text-caption mx-0 py-0" dense >
                                  <v-list-item link v-if="offer.status !== 'close'">
                                    <v-list-item-title>
                                      <v-menu
                                        open-on-hover
                                        right
                                        offset-y
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <span  v-bind="attrs" v-on="on">
                                            Mover
                                            <v-icon>mdi-chevron-right</v-icon>
                                          </span>
                                        </template>
                                        <v-list dense>
                                          <v-list-item
                                            v-for="(colMenu, index) in cols"
                                            :key="index"
                                            link
                                            v-show="colMenu.status !== item.status"
                                            @click="globalColChange({to: colMenu.status, from: item.status})"
                                          >
                                            <v-list-item-title>
                                              {{ colMenu.name }}
                                            </v-list-item-title>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                                    </v-list-item-title>
                                  </v-list-item>
                                  <v-list-item link @click="globalDownloadCV(item.status)">
                                    <v-list-item-title>
                                      Descargar CV
                                    </v-list-item-title>
                                  </v-list-item>
                                  <v-list-item v-if="offer.status !== 'close'">
                                    <v-list-item-title>
                                      <v-menu
                                        open-on-hover
                                        right
                                        offset-y
                                        class="d-flex ma-0 pa-0 hola"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <span  v-bind="attrs" v-on="on">
                                            Enviar Email
                                            <v-icon>mdi-chevron-right</v-icon>
                                          </span>
                                        </template>
                                        <v-list dense>
                                          <v-list-item
                                            link
                                            :disabled="getQtyNoNotified[item.status] === 0"
                                            @click="globalSendMail({type: item.status, status: item.status})"
                                            v-if="item.status !== 'sent'"
                                          >
                                            <v-list-item-title>
                                              {{sendMailItem[item.status]}} ({{getQtyNoNotified[item.status]}})
                                            </v-list-item-title>
                                          </v-list-item>
                                          <v-list-item
                                            link
                                            :disabled="getQtyChecked[item.status] === 0"
                                            @click="globalSendMail({type: 'no-context', status: item.status})"
                                          >
                                            <v-list-item-title>
                                              Nuevo Mensaje ({{ getQtyChecked[item.status] }})
                                            </v-list-item-title>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-checkbox
                              :input-value="isAllChecked[item.status]"
                              value
                              color="#3BADFF"
                              dense
                              hide-details
                              class="d-flex ma-0 pa-0 justify-start ats-col__header-check shirk"
                              @change="(value) => globalCheck({status: item.status, value: value})"
                            ></v-checkbox>
                          </v-col>
                        </v-col>
                        <draggable
                          class=" offer-cols pt-0"
                          ghost-class="ghost-drag"
                          :list="postulations[item.status]"
                          group="candidateCards"
                          @change="changeCol({...$event, status: item.status}, postulations[item.status])"
                          draggable=".drag"
                        >
                          <CandidateCard
                            :class="offer.status !== 'close' ? 'drag' : ''"
                            v-for="(card, index) in postulations[item.status]"
                            :key="index"
                            :candidate="card"
                            :isChecked="card.check"
                            :cols="cols"
                            :offer="offer"
                            :dataCard="{ index: index, status: item.status }"
                            @file="getCV"
                            @rate="rate"
                            @checked="checked"
                            @send="notifySingle"
                            @changeCol="changeCol({...$event, status: item.status}, postulations[item.status])"
                            :ref="`childComponente-${item.status}`"
                          />
                        </draggable>
                      </v-col>
                    </v-col>
                  </v-container>
                </div>
              </v-col>
            </v-row>
        </v-container>
      </div>
    </div>
    <Notify 
      :dialogNotify="notify.open" 
      :context="notify" 
      :toCol="toCol"
      :offer="{title: offer.title, organization: offer.organization.name, id: offer.id}"
      @cancel="cancelMove" 
      @close="closeNotify" 
      @confirmed="changeConfirmed" 
      @confirmedGlobal="globalConfirmed"
      @updatePost="updatePost"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CandidateCard from "@/components/CandidateCard";
import Notify from "@/components/CandidateNotify";
import SideMenu from "@/components/SideMenu";
import { handleTxt } from "../libs/mixins";

export default {
    name: "OfferDashboard",

    components: {
        draggable,
        CandidateCard,
        SideMenu,
        Notify
    },

    props: ["offer"],

    data() {
        return {
            cols: [
                { name: "Postulantes", status: "sent" },
                { name: "Descartados", status: "discarded" },
                { name: "Entrevistas", status: "interviewing" },
                { name: "Seleccionados", status: "selected" },
            ],
            toCol: null,
            changes: [],
            notify: {
                to: [],
                open: false,
                toSent: false,
                toDiscarded: false, 
                toInterviewing: false,
                toSelected: false,
                new: null,
                globalCheck: false
            },
            postulations: {
                sent: [],
                discarded: [],
                interviewing: [],
                selected: []
            },
            isAllChecked: {
                sent: false,
                discarded: false,
                interviewing: false,
                selected: false
            },
            isDownload: false,
            gCol: null,
        };
    },

    created() {
        this.cols.forEach(item => {
            this.postulations[item.status] = this.offer.postulations.filter(post => {
                post.check = false;
                return post.status.private === item.status;  
            });
        });
    },

    computed: {
        getQtyNoNotified() {
            return {
                sent: this.postulations.sent.reduce((a, p) => !p.notified.sent && p.check ? a + 1 : a, 0),
                discarded: this.postulations.discarded.reduce((a, p) => !p.notified.discarded && p.check ? a + 1 : a, 0),
                interviewing: this.postulations.interviewing.reduce((a, p) => !p.notified.interviewing && p.check ? a + 1 : a, 0),
                selected: this.postulations.selected.reduce((a, p) => !p.notified.selected && p.check ? a + 1 : a, 0)
            };
        },
        getQtyChecked() {
            return {
                sent: this.postulations.sent.reduce((a, p) => p.check ? a + 1 : a, 0),
                discarded: this.postulations.discarded.reduce((a, p) => p.check ? a + 1 : a, 0),
                interviewing: this.postulations.interviewing.reduce((a, p) => p.check ? a + 1 : a, 0),
                selected: this.postulations.selected.reduce((a, p) => p.check ? a + 1 : a, 0)
            };
        },
        sendMailItem() {
            const sent = this.cols.find(c => "sent" === c.status).name;
            const discarded = this.cols.find(c => "discarded" === c.status).name;
            const interviewing = this.cols.find(c => "interviewing" === c.status).name;
            const selected = this.cols.find(c => "selected" === c.status).name;
            
            return {
                sent: sent.substring(0, 1) + sent.toLowerCase().substring(1, sent.length - 1),
                discarded: discarded.substring(0, 1) + discarded.toLowerCase().substring(1, discarded.length - 1),
                interviewing: interviewing.substring(0, 1) + interviewing.toLowerCase().substring(1, interviewing.length - 1),
                selected: selected.substring(0, 1) + selected.toLowerCase().substring(1, selected.length - 1)            
            };
        
        },
    },

    methods: {
        async updatePost(posts) {
            await posts.forEach(async post => {
                this.postulations[post.status.private] = await this.postulations[post.status.private].map(p => {
                    if (p.id === post.id) {
                        p.notified = post.notified;
                    }
                    return p;
                });
            });
        },
        async notifySingle(value) {
            this.notify = {
                ...this.notify,
                users: [{
                    name: `${value.card.user.firstName} ${value.card.user.lastName}`,
                    email: value.card.user.email,
                    postId: value.card.id,
                    status: value.card.status,
                    notified: value.card.notified
                }],
                new: value.context,
                toSent: false,
                toDiscarded: false, 
                toInterviewing: false,
                toSelected: false
            };
            this.notify.open = true;
        },
        async changeConfirmed() {
            await this.changes.forEach(async({ value, list }) => {
                if (value && value.from && value.to && value.card) {
                    const cardIndex =  await this.postulations[value.from.status].findIndex(p => p.id === value.card.id);
                    await this.postulations[value.from.status].splice(cardIndex, 1);
                    await this.postulations[value.to].splice(0, 0, value.card);
                    await this.updateStatus([
                        {
                            id: value.card.id,
                            status: {
                                private: value.to,
                                public: "sent",
                            }
                        }
                    ]);
                    await this.cleanChecked();
                } else if (value.added) {
                    await this.updateStatus([
                        {
                            id: value.added.element.id,
                            status: {
                                private: value.status,
                                public: "sent",
                            }
                        }
                    ]);
                }
            });
            await this.cleanChecked();
            this.changes = [];
        },
        async closeNotify() {
            this.notify = {
                open: false,
                toSent: false,
                toDiscarded: false, 
                toInterviewing: false,
                toSelected: false,
                new: null
            };
            this.notify.open = false;
            await this.cleanChecked();
        },
        async cancelMove() {
            await this.closeNotify();
            await this.changes.forEach(({ value, list }) => {
                if (value.added) {
                    let { newIndex } = value.added;
                    list.splice(newIndex, 1);
                }

                if (value.removed) {
                    let { oldIndex, element } = value.removed;
                    list.splice(oldIndex, 0, element);
                }

                if (value.moved) {
                    let { newIndex, oldIndex, element } = value.moved;
                    list[newIndex] = list[oldIndex];
                    list[oldIndex] = element;
                }
            });
            this.changes = [];
            this.cleanChecked();
        },
        async changeCol(value, list) {
            this.changes.push({ value, list });
            // if (value && value.added && value.status === "sent") {
            //     this.changeConfirmed();
            //     return;
            // }
            // else if (value && value.to && value.status === "sent") {
            //     this.changeConfirmed();
            //     return;
            // } 
            if (value.from && value.to && value.card) {
                this.notify = {
                    ...this.notify,
                    new: null,
                    users: [{
                        name: `${value.card.user.firstName} ${value.card.user.lastName}`,
                        email: value.card.user.email,
                        postId: value.card.id,
                        status: value.card.status,
                        notified: value.card.notified
                    }],
                    toSent: value.to === "sent",
                    toDiscarded: value.to === "discarded",
                    toInterviewing: value.to === "interviewing",
                    toSelected: value.to === "selected"
                };
                this.notify.open = true;
                this.toCol = value;
            } else if (value.added) {
                this.notify = {
                    ...this.notify,
                    new: null,
                    users: [{
                        name: `${value.added.element.user.firstName} ${value.added.element.user.lastName}`,
                        email: value.added.element.user.email,
                        postId: value.added.element.id,
                        status: value.added.element.status,
                        notified: value.added.element.notified
                    }],
                    toSent: value.status === "sent",
                    toDiscarded: value.status === "discarded", 
                    toInterviewing: value.status === "interviewing",
                    toSelected: value.status === "selected"
                };
                this.notify.open = true;
                this.toCol = value;
            } else if (value.removed) {
                // this.postulations[value.status][value.removed.oldIndex].check = false;
                value.removed.element.check = false;
                await this.cleanChecked();
            }
            // else {
            // }
        },
        reduceCheck(value) {
            return this.postulations[value].every(item => item.check);
        },
        checked(value) {
            if (value.state) {
                this.postulations[value.status].find(post => {
                    if (post.id === value.postId) {
                        post.check = value.state;
                    }
                });
            }
            if (!value.state) {
                this.postulations[value.status].find(post => {
                    if (post.id === value.postId) {
                        post.check = value.state;
                    }
                });
            }
            this.isAllChecked[value.status] = this.reduceCheck(value.status);
        },
        downloadSheet() {
            this.isDownload = true;
            this.$store.dispatch("offers/sheet", {
                offerId: this.offer.id
            }).then((value) => {
                console.warn("Change Post Status");
                let url = process.env.VUE_APP_ROOT_ASSETS + value.path;

                fetch(url).then((t) => {
                    t.blob().then((b) =>  {
                        let a = document.createElement("a");
                        a.target = "_blank";
                        a.href = url;
                        a.click();
                        files.push(url);
                        this.isDownload = false;
                    }).catch(() => {
                        this.isDownload = false;
                    });
                }).catch(() => {
                    this.isDownload = false;
                });
            }).catch((err) => {
                console.error(err);
                this.isDownload = false;
            });
        },
        updateOffer() {
            this.$router.push({ name: "OfferEdit", params: { offerObs: this.offer } });
        },
        async cleanChecked() {
            await this.cols.forEach(async(col) => {
                await this.postulations[col.status].forEach(async(post) => {
                    if (post.id) {
                        post.check = false;
                        post.status.private = col.status;
                    }
                });
            });
            this.isAllChecked.sent = false;
            this.isAllChecked.discarded = false;
            this.isAllChecked.interviewing = false;
            this.isAllChecked.selected = false;
        },
        async updateStatus(postulations) {
            await this.$store.dispatch("users/postUpdate", {
                offerId: this.offer.id,
                postulations: postulations,
            });
            await this.cleanChecked();
        },
        async globalConfirmed(value) {
            const posts = [];
            
            this.postulations[this.gCol.from] = this.postulations[this.gCol.from].filter(p => {
                if (p.check) {
                    p.status.private = this.gCol.to; 
                    this.postulations[this.gCol.to].splice(0, 0, p);
                    posts.push(p);
                } else {
                    return p;
                }
            });
            await this.cleanChecked();
            await this.updateStatus(posts);
            this.isAllChecked[this.gCol.to] = false;
            this.isAllChecked[this.gCol.from] = false;
            this.toCol = null;
            this.gCol = null;
        },
        async globalColChange({ from, to }) {
            this.gCol = { from, to };
            this.toCol = this.gCol;
            const posts = await this.postulations[this.gCol.from].filter(p => p.check);
            this.notify = {
                ...this.notify,
                users: await posts.map(p => ({
                    name: `${p.user.firstName} ${p.user.lastName}`,
                    postId: p.id,
                    email: p.user.email,
                    status: p.status,
                    notified: p.notified
                })),
                toSent: to === "sent",
                toDiscarded: to === "discarded", 
                toInterviewing: to === "interviewing",
                toSelected: to === "selected"
            };
            this.notify.open = true;
        },
        globalDownloadCV(status) {
            this.postulations[status].forEach(card => {
                if (card.check === true && card.user.resume !== "") {
                    let filename = card.user.resume;
                    let url = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_RESUME_PATH + filename;
                    fetch(url).then((t) => {
                        t.blob().then((b) =>  {
                            let a = document.createElement("a");
                            a.href = URL.createObjectURL(b);
                            a.setAttribute("download", filename);
                            a.click();
                            files.push(b);
                        });
                    });
                }
            });
        },
        async globalSendMail({ type, status }) {
            const usersChecked = type !== "no-context" ? this.postulations[status].filter(p => !p.notified[status] && p.check) 
                : this.postulations[status].filter(p => p.check);
            this.notify = {
                ...this.notify,
                globalCheck: true,
                new: type,
                users: await usersChecked.map(p => ({
                    name: `${p.user.firstName} ${p.user.lastName}`,
                    email: p.user.email,
                    postId: p.id,
                    status: {
                        ...p.status,
                        private: status
                    },
                    notified: p.notified
                })),
                toSent: false,
                toDiscarded: false, 
                toInterviewing: false,
                toSelected: false
            };
            this.notify.open = true;
            this.toCol = { to: status, from: status };
        },
        globalCheck({ status, value }) {
            this.postulations[status].forEach(async(post) => await this.checked({ state: value, postId: post.id, status }));
            this.reduceCheck(status);
        },
        async rate(value) {
            const status = value.candidate.status.private;
            this.postulations[status] = await this.postulations[status].map(p => p.id === value.candidate.id ? { ...p, rate: value.rate } : { ...p });
            await this.updateStatus([{ ...value.candidate, rate: value.rate }]);
            // this.isAllChecked();
        },
        getCV(file) {
            return process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_RESUME_PATH + file;
        }
    },
};
</script>
